import { createI18n } from "vue-i18n";
import fr from "@/locales/fr.json";

/** Bootstrap ``vue-i18n`` and expose it as ``useNuxtApp().$i18n`` so any
 * non-Vue context (API client interceptor, services, etc.) can call
 * ``$i18n.global.t(key)`` without importing the instance directly. */
export default defineNuxtPlugin(({ vueApp }) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: "fr",
    fallbackLocale: "en",
    messages: { fr },
  });
  vueApp.use(i18n);
  return { provide: { i18n } };
});
